import React from 'react';
import { motion } from 'framer-motion';
export function AboutEvening() {
  return <section className="py-24 px-4 relative" data-id="element-8">
      <div className="max-w-3xl mx-auto text-center" data-id="element-9">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-10">
          <h2 className="text-4xl md:text-5xl font-serif text-velvet mb-8" data-id="element-11">
            About the <br className="md:hidden" data-id="element-12" />
            <span className="text-carrot italic" data-id="element-13">Talk</span>
          </h2>

          <div className="space-y-6 text-lg text-velvet/80 font-light leading-relaxed" data-id="element-14">
            <p data-id="element-15">
              AI is changing how the web is built — from the first wireframe to
              the production deploy. In a single morning we'll walk through what
              has actually shifted in the day-to-day of designers, developers,
              and the teams who ship software.
            </p>
            <p data-id="element-16">
              Expect a coffee reception, three short talks, a live demo, and
              plenty of time for questions. Whether you're hands-on with code or
              simply curious how your team's workflow is evolving, you'll leave
              with a clearer picture of where things are heading.
            </p>
            <p className="text-gold italic" data-id="element-17">
              Because in business, as in magic, the real trick is knowing where
              to look.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}